export default "__VITE_ASSET__21ZQQ9gg__"